import { useLocation } from "react-router-dom";
import Page from "src/components/Report/Page";

export default function Page6t() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");
    let damanehayeErtebati;
    if (JSON.parse(localStorage?.data)?.[jobId]?.damanehayeErtebati) {
        damanehayeErtebati = JSON.parse(localStorage?.data)?.[jobId].damanehayeErtebati
    } else {
        damanehayeErtebati = []
    }


    let abzarhaVaTajhizat;
    if (JSON.parse(localStorage?.data)?.[jobId]?.abzarhaVaTajhizat) {
        abzarhaVaTajhizat = JSON.parse(localStorage?.data)?.[jobId]?.abzarhaVaTajhizat
    } else {
        abzarhaVaTajhizat = []
    }
    return (
        <Page pageNumber={6}>
            <div className="font-bold text-lg">
                <span> ‌دامنه‌های ارتباطی‌</span>
            </div>
            <p className="text-black text-justify">
            دامنه‌های ارتباطی به طیف و نوع تعاملات شغلی فرد با سایر نقش‌ها، واحدها، مشتریان یا نهادهای بیرونی اشاره دارد. این بخش مشخص می‌کند که شاغل با چه کسانی، در چه سطوحی (درون‌سازمانی یا برون‌سازمانی) و با چه هدفی ارتباط برقرار می‌کند. تعیین دقیق این دامنه‌ها به طراحی فرآیندهای کاری، مهارت‌های ارتباطی مورد نیاز و ارزیابی اثربخشی شغلی کمک می‌نماید. درج این بخش، شفافیت نقش و هماهنگی بین‌واحدی را تسهیل می‌کند.
            </p>
            <div className="flex flex-col">
                {
                    Object.keys(damanehayeErtebati).sort(function (a, b) { return damanehayeErtebati[b].value - damanehayeErtebati[a].value }).map((key, index) => {
                        if (damanehayeErtebati[key].value >= 1) {
                            return (
                                <div className="flex items-center gap-3 odd-color">
                                    <div className="w-[60px] max-w-[60px] min-w-[60px] bg-gray-300 h-[10px] rounded">
                                        <div className="bg-[#5b5cff] h-[10px] rounded" style={{ width: `${(((damanehayeErtebati[key].value / 5) * 100) * 60) / 100}px` }}></div>
                                    </div>
                                    <div className="border-r-2 px-2">{key}</div>
                                </div>
                            )
                        }
                    })
                }
            </div>
            <p className="rounded-lg p-4 text-justify">
                همانطور که مشخص است در این شغل ‌
                <span className="text-gray-800">
                    {damanehayeErtebati &&
                        Object.keys(damanehayeErtebati).sort(function (a, b) { return damanehayeErtebati[b].value - damanehayeErtebati[a].value }).map((key, index) => {
                            if (index < 2) {
                                return (key) + "، "
                            }
                        })}
                </span>
                از بالاترین اهمیت و ‌
                <span className="text-gray-800">
                    {damanehayeErtebati &&
                        Object.keys(damanehayeErtebati).sort(function (a, b) { return damanehayeErtebati[a].value - damanehayeErtebati[b].value }).map((key, index) => {
                            if (index < 2) {
                                return (key) + "، "
                            }
                        })}
                </span>
                و ... از کمترین اهمیت برخوردارند.
            </p>
            <div className="font-bold text-lg">
                <span>ابزارها و تجهیزات مورد نیاز شغل :</span>
            </div>
            <p className="text-black text-justify">
                این بخش شامل فهرست ابزارها، تجهیزات و امکانات فیزیکی یا نرم‌افزاری است که برای انجام مؤثر وظایف شغلی ضروری‌اند. اقلام مورد نیاز بسته به ماهیت شغل می‌توانند شامل رایانه، نرم‌افزارهای تخصصی، تجهیزات اداری، یا ابزارهای ارتباطی باشند. تعیین دقیق این موارد به طراحی محیط کار استاندارد و افزایش بهره‌وری کمک می‌کند. همچنین مبنایی برای برنامه‌ریزی تأمین، نگهداری و به‌روزرسانی تجهیزات سازمانی فراهم می‌سازد.
            </p>
            <div className="flex gap-2 flex-wrap">
                {
                    Object.keys(abzarhaVaTajhizat).map((key, index) => {
                        if (abzarhaVaTajhizat[key]) {
                            return (
                                <div className="flex flex-row items-center gap-3  flex-wrap">

                                    <div className="px-3 bg-[#5b5cff] text-white p-2 rounded whitespace-nowrap">{key}</div>
                                </div>
                            )
                        }
                    })
                }
            </div>
        </Page>
    )
}